import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';
import T6 from '../../components/ExcerciseTypes/TypeIn/T6';
import UI from '../../components/ExcerciseTypes/Design/UserInterface';

const json = {
  1: {
    unit: 'Review 4',
    id: 'WB3-PV4-P87-E1',
    audio: '',
    video: '',
    component: DesignUnderLine,
    totalInput: 3,
    titleImage: '',
    exerciseKey: 'img/FriendsPlus/Page87/E1/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page87/E1/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page87/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page87/E1/3.jpg', input: 1, isCorrect: true },
        { url: 'img/FriendsPlus/Page87/E1/4.jpg', input: 1, },
        { url: 'img/FriendsPlus/Page87/E1/5.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page87/E1/6.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page87/E1/7.jpg' },
        { url: 'img/FriendsPlus/Page87/E1/8.jpg', input: 2, isCorrect: true },
        { url: 'img/FriendsPlus/Page87/E1/9.jpg', input: 2, },
        { url: 'img/FriendsPlus/Page87/E1/10.jpg' },
        { url: 'img/FriendsPlus/Page87/E1/11.jpg', input: 3, },
        { url: 'img/FriendsPlus/Page87/E1/12.jpg', input: 3, isCorrect: true },
        { url: 'img/FriendsPlus/Page87/E1/13.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page87/E1/14.jpg' },
      ],

    ]
  },
  2: {
    unit: 'Review 4',
    id: 'WB3-PV4-P87-E2',
    audio: '',
    video: '',
    component: D1,
    exerciseKey: 'img/FriendsPlus/Page87/E2/Key/answerKey.png',
    titleImage: '',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page87/E2/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page87/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page87/E2/3.jpg', input: true, answer: "weren't" },
        { url: 'img/FriendsPlus/Page87/E2/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page87/E2/5.jpg' },
        { url: 'img/FriendsPlus/Page87/E2/6.jpg', input: true, answer: "wasn't" },
        { url: 'img/FriendsPlus/Page87/E2/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page87/E2/8.jpg' },
        { url: 'img/FriendsPlus/Page87/E2/9.jpg', input: true, answer: "was" },
        { url: 'img/FriendsPlus/Page87/E2/10.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page87/E2/11.jpg' },
        { url: 'img/FriendsPlus/Page87/E2/12.jpg', input: true, answer: "weren't" },
        { url: 'img/FriendsPlus/Page87/E2/13.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page87/E2/14.jpg' },
        { url: 'img/FriendsPlus/Page87/E2/15.jpg', input: true, answer: "was" },
        { url: 'img/FriendsPlus/Page87/E2/16.jpg' },
      ],

    ]
  },
  3: { // Exercise num
    unit: 'Review 4',
    id: 'WB3-PV4-P87-E3',
    audio: '',
    video: '',
    component: T6,
    hideBtnFooter: true,
    stylesTextInput: { backgroundColor: 'transparent', border: 'none', padding: 0 },
    exerciseKey: 'img/FriendsPlus/Page84/E3/Key/answerKey.png',
    inputSize: 355,
    // titleQuestion: [{ num: '3', title: 'Listen and write. Then listen again and repeat. <headphone name="25" src="img/FriendsPlus/Page83/Audio/tieude-e2-p83.mp3"></headphone>', color: "#5B5A5D" }],
    // titleImage: "img/FriendsPlus/Page60/E1/1.jpg",
    // titleQuestion: [{ num: '1', title: 'Read the sentences and number the picture.', color: "#5B5A5D" }],
    questionImage: [],
    questions: [
      {
        title: `
        <div style=" position: relative; ">
          <div> <img src='img/FriendsPlus/Page87/E3/1.jpg' /> </div>
          <div style=" position: absolute; top: 61px; left: 305px; "><input id='0' /></div>
          <div style=" position: absolute; top: 115px; left: 587px; "><input id='1' /></div>
          <div style=" position: absolute; top: 168px; left: 349px; "><input id='2' /></div>
          <div style=" position: absolute; top: 222px; left: 410px; "><input id='3' /></div>
          <div style=" position: absolute; top: 275px; left: 429px; "><input id='4' /></div>
          <div style=" position: absolute; top: 328px; left: 460px; "><input id='5' /></div>
          <div style=" position: absolute; top: 382px; left: 376px; "><input id='6' /></div>

          

        </div>
        `,
        answer: [
          "On the farm",
          "horse",
          "sheep",
          "hen",
          "happy",
          "happy",
          "happy",
        ],
      },
    ],
  },




}
export default json;